import React, {useCallback, useEffect, useState} from 'react';
import {useSearchParams} from "react-router-dom";
import Fetching from "./fetching";
import {monthNames} from "./utils/utils";
import HeaderSubPage from "./partial/HeaderSubPage";
import CalendarBody from "./partial/calendarBody";
import InfiniteScroll from "react-infinite-scroller";
import axiosConfig from "./utils/axiosConfig";
import SearchForm from "./partial/search-form";
import {Accordion} from "react-bootstrap";

const bgImage = process.env.PUBLIC_URL + "/images/headers/Reisekalender-min.png"

const Calendar = ({partner, tripTypes, destinations}) => {

    const [searchParams] = useSearchParams();
    const [search, setSearch] = useState(searchParams.get("s") ?? "");
    const [type, setType] = useState(searchParams.get("reiseart") ?? "");
    const [dest, setDest] = useState(searchParams.get("reiseziel") ?? "");

    const [calendarYearMonth, setCalendarYearMonth] = useState([]);

    const [nextPage, setNextPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [fetching, setFetching] = useState(false);
    const [hasMoreItems, setHasMoreItems] = useState(true);

    const fetchCalendarYearMonth = useCallback(async () => {
        if (fetching) return;

        setFetching(true);
        try {
            const response = await axiosConfig.get(`/agency/${process.env.REACT_APP_AGENCY_NO}/calendar-months?type=${type}&dest=${dest}&search=${search}`);

            setCalendarYearMonth([...calendarYearMonth, ...response.data])
            setNextPage(1)
            setLastPage(1)
            setHasMoreItems(false)
        } catch (error) {
            console.error("Error fetching data:", error);
            return [];
        } finally {
            setFetching(false);
        }

    }, [nextPage, lastPage, fetching]);

    useEffect(() => {
        document.title = `${partner?.name} - Reisekalender`;
    }, [partner]);

    // Call fetchData on component mount
    useEffect(() => {
    }, []);

    return (
        <div>
            <div className="site wrapper-content">
                <HeaderSubPage title={'Reisekalender'} subtitle={'Reisekalender'} bgImage={bgImage}></HeaderSubPage>
                <section className="content-area">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="widget-area col-md-3 col-sm-12">
                                <SearchForm tripTypes={tripTypes} destinations={destinations} showBadge={true}
                                            action={`${process.env.PUBLIC_URL}/reisekalender/`}></SearchForm>
                            </div>
                            <div className="col-md-9 col-sm-12">
                                <div className="accordion" id="accordionPanelsStayOpenExample">
                                    <div className="accordion" id="accordionPanelsStayOpenExample">
                                        <InfiniteScroll
                                            loadMore={fetchCalendarYearMonth}
                                            hasMore={hasMoreItems}
                                            loader={<Fetching isFetching={fetching}></Fetching>}
                                        >
                                            <Accordion defaultActiveKey="0">
                                                {calendarYearMonth.map((row, rowIndex) => (
                                                    <Accordion.Item eventKey={rowIndex}>
                                                        <Accordion.Header>{monthNames[Number(row.month) - 1]} {row.year}</Accordion.Header>
                                                        <Accordion.Body>
                                                            <CalendarBody month={row.month} year={row.year}
                                                                          search={search}
                                                                          shown={document.getElementById('accordion-button' + rowIndex)?.getAttribute("aria-expanded")}
                                                            ></CalendarBody>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                ))}
                                            </Accordion>
                                        </InfiniteScroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )


}

export default Calendar;